//
// pull configuration out from /configuration.js file
//
export const getMainTouchUrl = window.GLOBAL_CONFIGURATION.getMainTouchUrl ;
export const getMainGlobeUrl = window.GLOBAL_CONFIGURATION.getMainGlobeUrl ;
export const getTermsAndConditionsLink = window.GLOBAL_CONFIGURATION.getTermsAndConditionsLink ;
export const getInstanceUrlFromIdent = window.GLOBAL_CONFIGURATION.getInstanceUrlFromIdent ;
export const getInstanceNameLabel = window.GLOBAL_CONFIGURATION.getInstanceNameLabel ;
export const getChangePasswordRedirectUrl = window.GLOBAL_CONFIGURATION.getChangePasswordRedirectUrl ;
export const getApiPrefix_touch = window.GLOBAL_CONFIGURATION.getApiPrefix_touch;
export const getApiPrefix_globe = window.GLOBAL_CONFIGURATION.getApiPrefix_globe;
export const getApiPrefix_lagoon = window.GLOBAL_CONFIGURATION.getApiPrefix_lagoon;
export const getReactRouterBasename =  window.GLOBAL_CONFIGURATION.getReactRouterBasename;
export const getUrlToOpenInstanceInNewWindow =  window.GLOBAL_CONFIGURATION.getOpenInstanceInNewWindowUrl;
export const getDesktopClientUrl =  window.GLOBAL_CONFIGURATION.getDesktopClientUrl;



// WEBPACK FOOTER //
// ./src/constants.js